import axios from 'axios'
import store from '../store'

export default {
    methods: {
        setDefaultCust: function() { //cliente por defecto de la delegación
            axios.post(this.ApiBaseUrl + 'CustSearch/GetDefaultCust',JSON.stringify(store.state.PosId),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                store.commit('setCust', response.data[0])
                store.commit('updateCombineShipments', this.$store.state.customer.combineShip)                 
            })
        },
        setDefaultSalesPerson(userid) { //cliente por defecto de la delegación
            console.log(userid)
            this.axios.post(this.ApiBaseUrl + 'CustSearch/GetDefaultSalesPerson',JSON.stringify(userid),{headers: {"Content-Type": "application/json"}})
            .then((SalesPersonRes) => {        
                this.$store.commit('setSalesPerson', SalesPersonRes.data[0])
                                                                      
            })
        },
        parkSale(parmInUse = 1) { 
            var SalesOrder = {
                DocType: this.$store.state.curDocType,
                OrderNo: this.$store.state.curOrder, 
                CustNo : this.$store.state.customer.id,
                PosId: this.$store.state.PosId,
                OrderProps: this.$store.state.orderproperties,
                SalesLines : this.$store.state.items,
                InUse: parmInUse
            }         

            if (SalesOrder.OrderNo == ""){
                switch (SalesOrder.DocType) {
                    case 1: //1=order
                        return this.axios.post(this.ApiBaseUrl + 'Sales/CreateSalesOrder',                
                            JSON.stringify(SalesOrder),
                            {headers: {"Content-Type": "application/json"}})            
                        .then((response) => {        
                            this.$store.commit('setcurOrder',response.data.message)
                            var res = response;                    
                    })
                    break;
                    case 0: //0=quote
                        return this.axios.post(this.ApiBaseUrl + 'SalesQuote/CreateSalesQuote',                
                            JSON.stringify(SalesOrder),
                            {headers: {"Content-Type": "application/json"}})            
                        .then((response) => {        
                            this.$store.commit('setcurOrder',response.data.message)
                            var res = response;                    
                    })
                    break;
                    case 5: //4=crmemo
                        return this.axios.post(this.ApiBaseUrl + 'ReturnOrder/CreateReturnOrder',                
                            JSON.stringify(SalesOrder),
                            {headers: {"Content-Type": "application/json"}})            
                        .then((response) => {        
                            this.$store.commit('setcurOrder',response.data.message)
                            var res = response;                    
                    })
                }
            }
            else{
                switch (SalesOrder.DocType) {
                    case 1: //1=order
                           return axios.post(this.ApiBaseUrl + 'Sales/UpdateSalesOrder',
                                    JSON.stringify(SalesOrder),
                                    {headers: {"Content-Type": "application/json"}})            
                                .then((response) => {        
                                    //this.options = response.data;
                                    var res = response;                     
                                })                    
                        break;
                    case 0: //0=quote
                        return axios.post(this.ApiBaseUrl + 'SalesQuote/UpdateSalesQuote',
                            JSON.stringify(SalesOrder),
                            {headers: {"Content-Type": "application/json"}})            
                        .then((response) => {        
                            //this.options = response.data;
                            var res = response;
                            return (res.data)                  
                        })
                        break;
                    case 5: //0=returnOrder
                        return axios.post(this.ApiBaseUrl + 'ReturnOrder/UpdateReturnOrder',
                            JSON.stringify(SalesOrder),
                            {headers: {"Content-Type": "application/json"}})            
                        .then((response) => {        
                            //this.options = response.data;
                            var res = response;                     
                        })
                    }
            }
            return ("0")
        },
        CalcDisc(req){
            return axios.post(this.ApiBaseUrl + 'PosFunctions/CalcDisc',
                        JSON.stringify(req),
                        {headers: {"Content-Type": "application/json"}})            
            .then((response) => {        
                //this.options = response.data;
                var res = response;                            
            })
            
        },
        RecoverSale(DocumentNo)
        {
            this.$store.dispatch("resetPOSRecover")            
                let SearchReq = 
                {
                    DocNo : DocumentNo,
                    OrderType: this.$store.state.curDocType                        
                }
                return this.axios.post(this.ApiBaseUrl + 'Sales/ReadSalesOrder',
                        //JSON.stringify(this.form.OrderId),
                        JSON.stringify(SearchReq),
                        {headers: {"Content-Type": "application/json"}})            
                .then((response) => {        
                    //this.options = response.data;
                    var res = response.data[0]                    
                    if (res != null) {
                        //Recuperación de la venta
                       
                        //Vendedor
                        var search = res.salesPersonId
                        this.axios.post(this.ApiBaseUrl + 'CustSearch/GetSalesPerson',JSON.stringify(search),{headers: {"Content-Type": "application/json"}})
                        .then((SalesPersonRes) => {        
                            this.$store.commit('setSalesPerson', SalesPersonRes.data[0])                                                             
                        })
                        //Anticipos
                        this.axios.post(this.ApiBaseUrl + 'PosFunctions/GetPrePayments',JSON.stringify(res.no),{headers: {"Content-Type": "application/json"}})
                        .then((PrepaymentsRes) => {        
                            this.$store.commit('setorderPrePayments',PrepaymentsRes.data)
                        })                        
                        //Líneas de pedido
                        res.salesLines.forEach(salesline => {
                            this.$store.commit('addItem', salesline)                             
                        });
                        this.$store.commit('setcurOrder',res.no)
                        this.$store.commit('setglobaldiscpct',res.globaldiscpct)  
                        this.$store.commit('setglobaldiscamount',res.globaldiscamount) 
                        this.$store.commit('updateCombineShipments', res.combineShipments)
                        this.$store.commit('SetExtDocNo', res.extDocNo)          
                        this.$store.commit('SetAuthContact', res.authContact)
                        this.$store.commit('SetShipToCode', res.shipToCode)
                        
                        let orderprops = {
                            custName2 : res.custName2,
                            custAddr : res.custAddr,
                            custPostCode : res.custPostCode,
                            custCity : res.custCity,
                            custVATNo : res.custVATNo
                        }
                        console.log(orderprops)
                        this.$store.commit('setOrderproperties', orderprops)                       

                         //Cliente
                         var search = res.custNo                        
                        
                         this.axios.post(this.ApiBaseUrl + 'CustSearch/GetCust',JSON.stringify(search),{headers: {"Content-Type": "application/json"}})
                          .then((CustRes) => {
                                //this.$store.commit('setCust', CustRes.data[0]).then((response) => {    
                                this.$store.dispatch("setCustomer", CustRes.data[0]).then((response) => {     
                                    this.parkSale() //Para marcarlo como "En uso"                                     
                               });                                                         
                         })
                    }
                    else {
                        this.alertvariant = "danger"
                        this.alerttxt = "Venta no encontrada"
                    }
                })                
        }
    },
    computed:{
        OrderTotal(){
            return parseFloat(this.$store.getters.OrderTotal).toFixed(2)
        },
        OrderTotalVAT(){
            return parseFloat(this.$store.getters.OrderTotalVAT).toFixed(2)
        },
        OrderTotalIncVAT(){
            return parseFloat(this.$store.getters.OrderTotalIncVAT).toFixed(2)
        },
        OrderDiscAmount(){
            return parseFloat(this.$store.state.globaldiscamount).toFixed(2)
        }
    }
}